import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLocation,
  fetchIpAddress,
  setPermission,
} from "../../redux/slice/locationSlice";

export const useLocationPermission = () => {
  const dispatch = useDispatch();
  const {
    locationOfUser,
    permission,
    locationError,
    ipError,
    loadingLocation,
    loadingIp,
    ipAddress,
  } = useSelector((state) => state.locationPermission);

  const [browserPermission, setBrowserPermission] = useState("prompt");

  // Check browser-level permission (not just our app-level flag)
 useEffect(() => {
  if (navigator.permissions) {
    navigator.permissions
      .query({ name: "geolocation" })
      .then((result) => {
        setBrowserPermission(result.state);

        if (result.state === "granted") {
          dispatch(setPermission("allowed"));
          dispatch(fetchLocation());
        } else if (result.state === "denied") {
          dispatch(setPermission("denied"));
        } else if (result.state === "prompt") {
          // Trigger popup once
          navigator.geolocation.getCurrentPosition(
            () => {
              dispatch(setPermission("allowed"));
              dispatch(fetchLocation());
            },
            () => {
              dispatch(setPermission("denied"));
            }
          );
        }

        result.onchange = () => {
          setBrowserPermission(result.state);

          if (result.state === "granted") {
            dispatch(setPermission("allowed"));
            dispatch(fetchLocation());
          } else if (result.state === "denied") {
            dispatch(setPermission("denied"));
          }
        };
      })
      .catch(() => {
        console.warn("Permissions API not supported.");
      });
  }

  // Fetch IP regardless of geolocation
  dispatch(fetchIpAddress());
}, [dispatch]);

  useEffect(() => {
    if (permission === "allowed") {
      if (!locationOfUser && !loadingLocation) {
        dispatch(fetchLocation());
      }
      if (!ipAddress && !loadingIp) {
        dispatch(fetchIpAddress());
      }
    }
  }, [permission, locationOfUser, ipAddress, dispatch, loadingLocation, loadingIp]);

  const locationAccess =
    permission === "allowed" &&
    browserPermission === "granted" &&
    locationOfUser != null;

  return {
    locationOfUser,
    ipAddress,
    loadingLocation,
    loadingIp,
    locationError,
    ipError,
    locationAccess,
    permissionStatus: permission,
    browserPermission,
  };
};
